import Marquee from "react-fast-marquee";
import { ShieldCheck, BadgeCheck, Wallet, Clock, Star, Wrench } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, text: "Fully insured" },
  { icon: BadgeCheck, text: "Vetted tradies" },
  { icon: Wallet, text: "Fixed pricing" },
  { icon: Clock, text: "24 hour response" },
  { icon: Star, text: "4.9 average rating" },
  { icon: Wrench, text: "1000+ jobs completed" },
];

export default function TrustMarquee() {
  return (
    <section
      className="bg-secondary text-secondary-foreground py-5 grain-overlay border-y border-black/20"
      data-testid="trust-marquee"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {[...ITEMS, ...ITEMS].map((it, i) => {
          const Icon = it.icon;
          return (
            <span key={i} className="marquee-item">
              <Icon size={16} className="text-primary" />
              <span>{it.text}</span>
              <span className="text-primary">·</span>
            </span>
          );
        })}
      </Marquee>
    </section>
  );
}
